module.exports = __webpack_public_path__ + "static/media/aniversariologo.d61ce426.jpg";